import { useState, useEffect } from 'react';
import { useService } from './useService';
import { POST } from 'services/RequestMethods';

export const usePasswordValidation = ({ 
    password = '', 
    password_confirm = '',
    extra_rules = false,
}) => {
    const [isValidLength, setValidLength] = useState(null);
    const [hasNumber, setHasNumber] = useState(null);
    const [hasUpperCase, setUpperCase] = useState(null);
    const [hasLowerCase, setLowerCase] = useState(null);
    const [doesMatch, setMatch] = useState(null);
    const [hasSpecialChar, setSpecialChar] = useState(null);
    const [sixMonths, setSixMonths] = useState(null);
    const [lastFive, setLastFive] = useState(null);

    const [{ data, loading }, fireCheckPassword] = useService({
        url: 'users/account/check/password',
        method: POST,
    });

    useEffect(() => {
        setValidLength(password.length >= 6 ? true : false);
        setUpperCase(password.toLowerCase() !== password);
        setLowerCase(password.toUpperCase() !== password);
        setHasNumber(/\d/.test(password));
        setMatch(password && password === password_confirm);
        setSpecialChar(/[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(password));
    }, [password, password_confirm]);

    useEffect(() => {
        async function checkPassword() {
            if (doesMatch && extra_rules) {
                await fireCheckPassword({
                    params: {
                        check: password || password_confirm,
                    },
                });
            }
            else {
                setSixMonths(null);
                setLastFive(null);
            }
        }
        
        checkPassword();
    }, [password, password_confirm, doesMatch]);

    useEffect(() => {
        if (data.password && doesMatch && extra_rules) {
            setSixMonths(!data.password.six_months);
            setLastFive(!data.password.last_five);
        }
    }, [data]);
    

    return extra_rules ? [
        isValidLength, 
        hasNumber, 
        hasUpperCase, 
        hasLowerCase, 
        doesMatch, 
        sixMonths, 
        lastFive, 
        loading,
    ] : [
        isValidLength, 
        hasNumber, 
        hasUpperCase, 
        hasLowerCase, 
        doesMatch, 
        loading,
    ];
};

export default usePasswordValidation;